/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { fromPhotos } from '../utils';

const FallbackImage = ({ src, placeholder, className, placeholderClassName, alt = 'Foto' }) => {
  const isExternal = String(src || '').startsWith('http') || String(src || '').startsWith('blob') || String(src || '').startsWith('data');
  const uri = isExternal ? src : fromPhotos(src || '');
  const [isBroken, setIsBroken] = useState(false);

  useEffect(() => {
    if (isBroken) setIsBroken(false);
  }, [src]);

  if (!src || isBroken) return (
    <img key="placeholder" src={placeholder} className={placeholderClassName} alt={alt} />
  );

  return (
    <img src={uri} className={className} onError={() => setIsBroken(true)} alt={alt} />
  );
};

export default FallbackImage;
